import React from 'react';
import 'katex/dist/katex.min.css';
import { InlineMath, BlockMath } from 'react-katex';
import ReactMarkdown from 'react-markdown';
import remarkMath from 'remark-math';
import rehypeKatex from 'rehype-katex';

interface LatexMarkdownProps {
  content: string;
}

const convertDelimiters = (text: string): string => {
  return text
    .replace(/\\\((.+?)\\\)/gs, (_, match) => `$${match}$`)     // \(...\) → $...$
    .replace(/\\\[(.+?)\\\]/gs, (_, match) => `$$${match}$$`);   // \[...\] → $$...$$
};

const LatexMarkdown: React.FC<LatexMarkdownProps> = ({ content }) => {
  const parsedContent = convertDelimiters(content);

  return (
    <div>
      <ReactMarkdown
        children={parsedContent}
        remarkPlugins={[remarkMath]}
        rehypePlugins={[rehypeKatex]}
        components={{
          math: ({ value }) => <BlockMath math={value} />,
          inlineMath: ({ value }) => <InlineMath math={value} />
        }}
      />
    </div>
  );
};

export default LatexMarkdown;
